import { PageToolbarProps } from '@st/document-viewer-kit'
import { DocumentPermission } from '@st/sdk'
import { ContextMenu, ContextMenuItem } from '@st/theme'

type Props = PageToolbarProps & {
  permissions: DocumentPermission[]
  isDeleted: boolean
  onDeletePage?: (pageNumber: number) => void
  onRestorePage?: (pageNumber: number) => void
}

/**
 * Toolbar displayed above each document page in the StanfordTax Document Viewer.
 * See {@link STPDFDocViewer} for more details.
 *
 * The toolbar shows the current page number and, when `showPageOperations` is enabled,
 * provides a context menu to delete/restore a page.
 */
export function STDocumentPageToolbar({
  page,
  permissions,
  isDeleted,
  onDeletePage,
  onRestorePage
}: Props) {
  return (
    <div className="flex w-full items-center justify-between">
      <span className="mb-2 text-xs text-white">Page {page.pageNumber}</span>
      {permissions.includes('delete_pages') && (
        <ContextMenu className="mb-2 !size-4">
          {!isDeleted ? (
            <ContextMenuItem onClick={() => onDeletePage?.(page.pageNumber)}>
              Delete page
            </ContextMenuItem>
          ) : (
            <ContextMenuItem onClick={() => onRestorePage?.(page.pageNumber)}>
              Restore page
            </ContextMenuItem>
          )}
        </ContextMenu>
      )}
    </div>
  )
}
